let middle_ware = "https://shift-worship-node-app.vercel.app/api";

// Function to handle custom sticker images upload and storage
const handleCustomStickerImages = async (storeData) => {
  
  // Extract the actual imageState from the wrapper object
  const imageState = storeData.imageState || storeData;
  
  if (!imageState || !imageState.annotation) {
    return storeData;
  }

  const customStickerUrls = [];
  const shapesToUpdate = [];

  // Loop through all shapes in the annotation
  for (let i = 0; i < imageState.annotation.length; i++) {
    const shape = imageState.annotation[i];
    
    // Check if this is a shape with a background image that uses a blob URL
    if (shape.backgroundImage && typeof shape.backgroundImage === 'string' && shape.backgroundImage.startsWith('blob:')) {
      shapesToUpdate.push({ index: i, shape, originalUrl: shape.backgroundImage });
    } else if (shape.backgroundImage) {
    }
  }

  // Process each shape with custom uploaded images
  for (const shapeInfo of shapesToUpdate) {
    try {
      
      // Fetch the blob from the blob URL
      const response = await fetch(shapeInfo.originalUrl);
      const blob = await response.blob();
      
      // Create a File object from the blob
      const fileName = `custom-sticker-${Date.now()}-${Math.random().toString(36).substr(2, 9)}.${blob.type.split('/')[1] || 'png'}`;
      const file = new File([blob], fileName, { type: blob.type });

      // Upload the file using the existing upload infrastructure
      const uploadedUrl = await uploadCustomStickerFile(file);
      
      if (uploadedUrl) {
        
        // Replace the blob URL with the uploaded URL
        imageState.annotation[shapeInfo.index].backgroundImage = uploadedUrl;
        customStickerUrls.push(uploadedUrl);
        
        // Clean up the blob URL
        URL.revokeObjectURL(shapeInfo.originalUrl);
      } else {
        console.error('Failed to upload custom sticker - no URL returned');
      }
    } catch (error) {
      console.error('Error processing custom sticker image:', error);
    }
  }

  // Update the custom_stickers metafield if we have new URLs
  if (customStickerUrls.length > 0) {
    await updateCustomStickersMetafield(customStickerUrls);
  }

  // Return the original storeData object (not just imageState)
  return storeData;
};

// Function to upload custom sticker file
const uploadCustomStickerFile = async (file) => {
  try {
    
    // Step 1: Get pre-signed URL from backend
    const presignedUrlResponse = await fetch(middle_ware + "/shopify/generate-presigned-url", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: file.name,
        fileType: file.type,
        isThumb: true // Set to true for sticker images
      }),
    });

    if (!presignedUrlResponse.ok) {
      throw new Error('Failed to get presigned URL for sticker upload');
    }

    const { presignedUrl, newFileName } = await presignedUrlResponse.json();

    // Step 2: Upload directly to S3 using presigned URL
    const uploadResponse = await fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error('Failed to upload sticker file to S3');
    }

    // Step 3: Notify backend of successful upload
    const notifyResponse = await fetch(middle_ware + "/shopify/upload-complete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: file.name,
        fileUrlFe: newFileName,
        customerId: window.customerId,
        originalName: file.name,
        fileType: file.type,
        customEditorFinal: false
      }),
    });

    if (notifyResponse.ok) {
      const finalUrl = `https://d2bzq90r37yl3y.cloudfront.net/quick-editor-customer/${newFileName}`;
      
      // Return the full URL for the uploaded sticker
      return finalUrl;
    } else {
      console.error("Error notifying backend of sticker upload completion");
      return null;
    }

  } catch (error) {
    console.error("Error uploading custom sticker file:", error);
    return null;
  }
};

// Function to update the custom_stickers metafield
const updateCustomStickersMetafield = async (newUrls) => {
  try {
    // Get existing custom stickers
    let existingUrls = [];
    if (typeof customStickerUrls !== 'undefined' && Array.isArray(customStickerUrls)) {
      existingUrls = [...customStickerUrls];
    }

    // Merge new URLs with existing ones, avoiding duplicates
    const allUrls = [...new Set([...existingUrls, ...newUrls])];

    // Use the existing updateMetfafields function format
    const objectValues = {
      custom_stickers: JSON.stringify(allUrls),
    };

    // Use the existing updateMetfafields function
    updateMetfafields(objectValues, customerId);

    
    // Update the global customStickerUrls variable for immediate use
    if (typeof customStickerUrls !== 'undefined') {
      customStickerUrls = allUrls;
    }
  } catch (error) {
    console.error("Error updating custom stickers metafield:", error);
  }
};

const updateEditor = (imageSrc) => {
  const dynamicImages = [];
  document.querySelectorAll(".editable-section img").forEach((img) => {
    dynamicImages.push(img.src);
  });

  const defaultFonts = [
    ["Viaoda Libre", "Viaoda Libre"],
    ["Helvetica, Arial, Verdana, 'Droid Sans', sans-serif", "Sans Serif"],
    ["'Arial Black', 'Avenir-Black', 'Arial Bold'", "Black"],
    ["'Arial Narrow', 'Futura-CondensedMedium'", "Narrow"],
    ["'Trebuchet MS'", "Humanist"],
    ["Georgia, 'Avenir-Black', 'Times New Roman', 'Droid Serif', serif", "Serif"],
    ["Palatino", "Old-Style"],
    ["'Times New Roman', 'TimesNewRomanPSMT'", "Transitional"],
    ["Menlo, Monaco, 'Lucida Console', monospace", "Monospaced"],
    ["'Courier New', monospace", "Slab Serif"],
      ...(fontPairs.length > 0 ? fontPairs : []),
  ];
  const customFonts = [];

  // Check if the metafield has a value assigned
  if (font_files) {
    const fontUrls = font_files.split(',');
    fontUrls.forEach((fontUrl) => {
      const parts = fontUrl.split('/').pop().split('-');
      const fontName = parts.slice(0, -1).join(' ').split('.')[0];

      // Create a new @font-face rule and append it to the document's head
      const style = document.createElement('style');
      style.textContent = `
        @font-face {
          font-family: '${fontName}';
          src: url('${fontUrl}');
        }
      `;
      document.head.appendChild(style);

      // Append the new font to the customFonts array
      customFonts.push([fontName, fontName]);
    });
  }
  const customFontSizeOptions = [12, 14, 16, 18, 20, 24, 30, 36, 48, 64, 72, 96, 144, 192, 255];
 
  let picker = undefined;

  let imported = false;
  var {
    plugin_trim,
    plugin_trim_locale_en_gb,
    createDefaultVideoWriter,
    createMediaStreamEncoder,
    createDefaultColorOptions,
    createMarkupEditorToolStyles,
  } = pinturavideo;

  var {
    setPlugins,
    createDefaultImageWriter,
    createDefaultMediaWriter,
    imageStateToCanvas,
    createDefaultColorOptions,
    createMarkupEditorToolStyles
  } = pintura;
  // Load trim plugin
  setPlugins(plugin_trim);
  const editorOptions = {
    src: imageSrc,
    markupEditorToolStyles: createMarkupEditorToolStyles({
      text: {
        // Set default font color to black
        color: createDefaultColorOptions().black,
        // Set default text shape background to transparent
        backgroundColor: [0, 0, 0, 0],
        // Set default text shape outline to 0 width and white
        textOutline: ['0%', [1, 1, 1]],
        // Set default text shadow, shadow will not be drawn if x, y, and blur are 0.
        textShadow: ['0%', '0%', '0%', [0, 0, 0, 0.5]],
        // Allow newlines in inline text
        disableNewline: false,
        // Align to left by default, this triggers always showing the text align control
        textAlign: 'left',
        // Enable text formatting
        format: 'html',
      },
    }),
    enableTapToAddText: true,
    stickerEnableSelectImagePreset: true,
    
    // Add event handlers to track when images are uploaded via sticker interface
    willRenderShapePresets: (items, env) => {
      return items;
    },

    // Track when stickers are added to the canvas
    stickerProcessSelectImage: (file) => {
      
      // Return the file to continue normal processing
      return file;
    },
 
    stickers: [
          
          [
            'All Elements',
            [
              {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-square-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-sideways-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-sides-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-lower-third-full-3-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-lower-third-full-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-lower-third-full-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-diamond-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-corners-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-circle-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-art-box-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-yellow-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-yellow-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-white-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-tablet-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-phone-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-peach-alt-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-peach-alt-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-peach-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-peach-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-pale-blue-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-pale-blue-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-off-white-4-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-off-white-3-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-off-white-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-off-white-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-mint-green-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-mint-green-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-magenta-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-magenta-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-lower-third-hd-full-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-lower-third-hd-full-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-light-peach-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-light-peach-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-light-blue-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-light-blue-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-icons-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-green-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-green-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-dots-4-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-dots-3-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-dots-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-dots-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-desktop-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-dashes-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-dashes-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-dark-blue-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-dark-blue-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-charcoal-6-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-charcoal-5-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-charcoal-4-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-charcoal-3-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-charcoal-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-charcoal-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-burnt-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-burnt-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-blue-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-alt-blue-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/brighter-days-alt-blue-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ascension-tablet-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ascension-phone-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ascension-lower-third-hd-full-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ascension-lower-third-hd-full-3-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ascension-lower-third-hd-full-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ascension-desktop-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/alpha-and-omega-trefoil-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/alpha-and-omega-lower-third-full-hd-3-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/alpha-and-omega-lower-third-full-hd-2-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/alpha-and-omega-lower-third-full-hd-1-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/alpha-and-omega-icthus-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/alpha-and-omega-dove-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/alpha-and-omega-cross-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/alpha-and-omega-alphaomega-transparency.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/bright-patches-brush-6.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/bright-patches-brush-5.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/bright-patches-brush-4.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/bright-patches-brush-3.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/bright-patches-brush-2.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/bright-patches-brush-1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-top.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-poly.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-pills.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-frame.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-flower.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-diamonds.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-cross.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-circles.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-boxes.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-box.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-bottom.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/starry-night-ascend.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ribbon-flow-circle6.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ribbon-flow-circle5.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ribbon-flow-circle4.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ribbon-flow-circle3.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ribbon-flow-circle2.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ribbon-flow-circle1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/simple-advent-ring.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/misty-mountain-square-1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/misty-mountain-circle-3.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-paint-2.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-paint-1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-dots-2.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-dots-1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/heavenly-lights-vast.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/geo-pop-box-3.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-10.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-9.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-8.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-7.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-6.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-5.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/facets-shape1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/altered-colors-diamond-5.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/altered-colors-diamond-1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/text-box-small-white.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/text-box-small-black.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/watercolor-cross-cross-4.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/watercolor-cross-cross-2.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/thanksgiving-flight-circles.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/text-box-large-white.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/text-box-large-black.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/star.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/nativity-glass-flare-3.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/nativity-glass-flare-1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/name-above-cross-2.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/name-above-cross-1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-2.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/line-1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-4.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-3.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-2.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/flare-1.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/facets-shape3.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ashcolors-cross6.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ashcolors-cross3.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ash-clouds-cross-white.png',width: '15%'},
            {
                src: 'https://d2bzq90r37yl3y.cloudfront.net/quick-editor/ash-clouds-cross-black.png',width: '15%'},
            ],
        ],
        // Add custom stickers section if any exist
        ...(typeof customStickerUrls !== 'undefined' && customStickerUrls.length > 0 ? [[
          'My Elements',
          customStickerUrls.map(url => ({
            src: url,
            width: '15%'
          }))
        ]] : []),
    ],
    
    // Keep only ONE plugins definition with trim options
    plugins: [
      pintura.plugin_resize, 
      [
        pinturavideo.plugin_trim,
        {
          trimEnableUpdateCurrentTimeOnTrim: true,
        }
      ]
    ],
    
    imageWriter: createDefaultMediaWriter(
      [
      createDefaultImageWriter({
        store: async (imageState, options) => {
          // Save custom sticker images before processing
          await handleCustomStickerImages(imageState);
          return imageState;
        }
      }),
        createDefaultVideoWriter({
          encoder: createMediaStreamEncoder({
            imageStateToCanvas,
            // output quality (optional)
            videoBitrate: 25000000, // 25MBps
          }),
          store: async (imageState, options) => {
            // Save custom sticker images before processing
            await handleCustomStickerImages(imageState);
            return imageState;
          }
        }),
      ]
    ),
    locale: {
      labelButtonExport: "Save",
      annotateLabel: "Text",
      annotateIcon:
        '<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 1V5C20.5 5.26522 20.3946 5.51957 20.2071 5.70711C20.0196 5.89464 19.7652 6 19.5 6C19.2348 6 18.9804 5.89464 18.7929 5.70711C18.6054 5.51957 18.5 5.26522 18.5 5V2H11.5V18H14.5C14.7652 18 15.0196 18.1054 15.2071 18.2929C15.3946 18.4804 15.5 18.7348 15.5 19C15.5 19.2652 15.3946 19.5196 15.2071 19.7071C15.0196 19.8946 14.7652 20 14.5 20H6.5C6.23478 20 5.98043 19.8946 5.79289 19.7071C5.60536 19.5196 5.5 19.2652 5.5 19C5.5 18.7348 5.60536 18.4804 5.79289 18.2929C5.98043 18.1054 6.23478 18 6.5 18H9.5V2H2.5V5C2.5 5.26522 2.39464 5.51957 2.20711 5.70711C2.01957 5.89464 1.76522 6 1.5 6C1.23478 6 0.98043 5.89464 0.792893 5.70711C0.605357 5.51957 0.5 5.26522 0.5 5V1C0.5 0.734784 0.605357 0.48043 0.792893 0.292893C0.98043 0.105357 1.23478 0 1.5 0H19.5C19.7652 0 20.0196 0.105357 20.2071 0.292893C20.3946 0.48043 20.5 0.734784 20.5 1Z" fill="#E3E3E3"/></svg>',
      fillLabel: "Background",
      fillIcon: '<svg width="21" height="20" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.5 0H2.5C1.96957 0 1.46086 0.210714 1.08579 0.585786C0.710714 0.960859 0.5 1.46957 0.5 2V20C0.5 20.5304 0.710714 21.0391 1.08579 21.4142C1.46086 21.7893 1.96957 22 2.5 22H24.5C25.0304 22 25.5391 21.7893 25.9142 21.4142C26.2893 21.0391 26.5 20.5304 26.5 20V2C26.5 1.46957 26.2893 0.960859 25.9142 0.585786C25.5391 0.210714 25.0304 0 24.5 0ZM24.5 2V14.8438L21.2412 11.5863C21.0555 11.4005 20.835 11.2531 20.5923 11.1526C20.3497 11.052 20.0896 11.0003 19.8269 11.0003C19.5642 11.0003 19.3041 11.052 19.0614 11.1526C18.8187 11.2531 18.5982 11.4005 18.4125 11.5863L15.9125 14.0863L10.4125 8.58625C10.0375 8.21146 9.52896 8.00093 8.99875 8.00093C8.46854 8.00093 7.96003 8.21146 7.585 8.58625L2.5 13.6712V2H24.5ZM2.5 16.5L9 10L19 20H2.5V16.5ZM24.5 20H21.8288L17.3288 15.5L19.8288 13L24.5 17.6725V20ZM15.5 7.5C15.5 7.20333 15.588 6.91332 15.7528 6.66665C15.9176 6.41997 16.1519 6.22771 16.426 6.11418C16.7001 6.00065 17.0017 5.97094 17.2926 6.02882C17.5836 6.0867 17.8509 6.22956 18.0607 6.43934C18.2704 6.64912 18.4133 6.91639 18.4712 7.20736C18.5291 7.49834 18.4993 7.79994 18.3858 8.07403C18.2723 8.34811 18.08 8.58238 17.8334 8.7472C17.5867 8.91203 17.2967 9 17 9C16.6022 9 16.2206 8.84196 15.9393 8.56066C15.658 8.27936 15.5 7.89782 15.5 7.5Z" fill="#E3E3E3"/></svg>',
      shapeTitleTextColor: "Color",
      stickerLabel: "Elements",
      statusImageLoadError: "Image failed to load. Please try another combination",
      shapeLabelButtonSelectSticker: "Upload Element",
      ...plugin_trim_locale_en_gb,
      
    },
  
    resizeSizePresetOptions: [
        [undefined, 'Auto'],
        [[1024, 1024], 'Square (1024x1024)'],
        [[1920, 1080], 'Full HD (1920x1080)'],
        [[1366, 768], 'TripleWide HD (3840x720)'],
        [[3840, 2160], '4K UHD (3840x2160)'],
    ],

    zoomLevel: undefined,
     // set the target size property to automatically select the HD
     imageTargetSize: {
      width: 1920,
      height: 1080,
    },
    imageCropAspectRatio: 1920 / 1080,
    markupEditorShapeStyleControls: pintura.createMarkupEditorShapeStyleControls({
      fontSizeOptions: customFontSizeOptions,
      fontSize: pintura.createMarkupEditorFontSizeControl(
          pintura.createMarkupEditorFontSizeOptions(customFontSizeOptions),
          {
              enableInput: true,
          }
      ),
 
      lineHeightOptions: pintura.createDefaultLineHeightOptions(),
      fontFamilyOptions: [...defaultFonts, ...customFonts],

      
      strokeWidth: {
        factory: 'defaultPercentage',
        options: {
            min: 0, // value for 0
            max: 10, // value for 100%
            title: 'line width',
        },
    },
    opacity: [
        'ToggleSlider',
        {
            title: 'Opacity',
            min: 0,
            max: 1,
            step: 0.01,
            label: (value, min, max) => `${Math.round((value / max) * 100)}%`,
            labelClass: 'PinturaPercentageLabel',
        },
    ],
    }),
    util: 'annotate',
    markupEditorSnapThreshold: 10,
    markupEditorSnapToContext: true,

    willRenderShapePresetToolbar: (toolbar, addPreset, env, redraw) => {
      // import from unpkg
      if (!imported) {
          import('https://unpkg.com/emoji-picker-element')
              .then(() => {
                  imported = true;
                  redraw();
              })
              // silently error out
              .catch(console.log);
          return toolbar;
      }

      // create root
      if (!picker) {
          // create the picker
          const emojiPicker = document.createElement('emoji-picker');

          // enable touch scroll of Pintura child element on iOS
          emojiPicker.dataset.touchScroll = 'true';

          // exit if no shadow root
          if (!emojiPicker.shadowRoot) return toolbar;

          // set custom styles to make it fit better
          const style = document.createElement('style');
          style.textContent = `
                          .favorites { display: none }
                          .emoji { border-radius: 0 }
                          button.emoji { border-radius: 0 }
                          .tabpanel {
                              scrollbar-color:#ddd transparent;
                              scrollbar-width: thin;
                          }
                          .tabpanel::-webkit-scrollbar {
                              width: 1rem;
                              cursor: pointer;
                          }
                          .tabpanel::-webkit-scrollbar-track {
                              background: none;
                          }
                          .tabpanel::-webkit-scrollbar-thumb {
                              cursor: pointer;
                              background-clip: padding-box;
                              background-color: #ddd;
                              border-radius: 9999rem;
                              border: 0.3125rem solid rgba(0, 0, 0, 0);
                          }
                      `;
          emojiPicker.shadowRoot.appendChild(style);

          // set theme, light or dark
          emojiPicker.className = 'light';

          // handle picking an emoji
          emojiPicker.addEventListener('emoji-click', (e) =>
            addSmiley(pintura, addPreset, e.detail.unicode)
          );
          picker = emojiPicker;
      }

      // append the picker Panel
      pintura.appendNode(
        pintura.createNode('Panel', 'emoji', {
              buttonLabel: 'Emoji',
              root: picker,
          }),
          toolbar
      );

      return toolbar;
  },

    
  };

  const inlineEditor = document.querySelector(".inline-editor");
  if (inlineEditor.textContent.length > 0) {
    inlineEditor.innerHTML = "";
  }
 
  // Initialize the editor
  window.pinturaEditor = pintura.appendDefaultEditor(".inline-editor", editorOptions);
  
  window.pinturaEditor.on("selectcontrol", (value) => {
    if (value === "text" || value === "sharpie") {
      // Select the active PinturaTabPanel
      let activePanel = document.querySelector('div.PinturaTabPanel[id*="annotate"]:not([hidden])');

      if (activePanel) {
        // Find the radio button and dispatch the change event
        const textRadio = activePanel.querySelector('.PinturaRadioGroupOption input[type="radio"][value="text"]');
        if (textRadio && !document.getElementById("fontUpload")) {
          // Check the radio button
          textRadio.checked = true;
          textRadio.click();
          // Trigger the change event
          const event = new Event("change");
          textRadio.dispatchEvent(event);

          // Create the new list item
          const newListItem = document.createElement("li");
          newListItem.className = "custom-font-upload";

          // Create the span element
          const span = document.createElement("span");
          span.className = "PinturaShapeStyleLabel";
          span.textContent = "Custom Font";

          // Create the file input
          const fileInput = document.createElement("input");
          fileInput.type = "file";
          fileInput.accept = ".woff,.woff2,.otf";
          fileInput.id = "fontUpload";

          // Add change event listener to the file input
          fileInput.addEventListener("change", (event) => {
            const file = event.target.files[0];
            if (!file) {
              showErrorPopup("No file selected!");
              return;
            }

            const reader = new FileReader();
            reader.onloadend = async () => {
              const base64File = reader.result.split(",")[1]; // Remove URL prefix
              const filename = file.name;
              const contentType = file.type;

              try {
                const response = await fetch(middle_ware + "/shopify/upload", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    file: base64File,
                    filename,
                    contentType,
                    customerId: window.customerId,
                    namespace: "font_files",
                  }),
                });

                const result = await response.json();
                if (response.ok) {
                  // Extract the font name without the extension
                  const fontName = filename.replace(/\.[^/.]+$/, "");
                  const fontUrl = result.fileUrl; // Assuming the response contains the URL of the uploaded font

                  // Create a new @font-face rule and append it to the document's head
                  const style = document.createElement('style');
                  style.textContent = `
                    @font-face {
                      font-family: '${fontName}';
                      src: url('${fontUrl}');
                    }
                  `;
                  document.head.appendChild(style);

                  // Append the new font to the customFonts array
                  customFonts.push([fontName, fontName]);
                  fontPairs.push([fontName, fontName]);
                  // Update the editor's font options
                  window.pinturaEditor.markupEditorShapeStyleControls = pintura.createMarkupEditorShapeStyleControls({
                     fontSizeOptions: pintura.createDefaultFontSizeOptions(),
                    lineHeightOptions: pintura.createDefaultLineHeightOptions(),
                    fontFamilyOptions: [...defaultFonts, ...customFonts],
                    strokeWidth: {
                      factory: 'defaultPercentage',
                      options: {
                          min: 0, // value for 0
                          max: 10, // value for 100%
                          title: 'line width',
                          
                      },
                  }
                  });

                  // Update the font list in the UI
                  const shapeStyleList = activePanel.querySelector(
                    '.PinturaControlPanels .PinturaShapeStyleEditor > div[style*="opacity: 1"] ul.PinturaShapeStyleList'
                  );
                  if (shapeStyleList) {
                    const newFontItem = document.createElement("li");
                    newFontItem.className = "PinturaShapeStyleListItem";
                    newFontItem.textContent = fontName;
                   }
                } else {
                  showErrorPopup("File not uploaded successfully:", result);
                }
              } catch (error) {
                showErrorPopup("Error uploading file:", error);
              }
            };

            reader.readAsDataURL(file);
          });

          // Append the span and file input to the list item
          newListItem.appendChild(span);
          newListItem.appendChild(fileInput);
          setTimeout(function () {
            // Append the new list item to the ul.PinturaShapeStyleList
            const shapeStyleList = activePanel.querySelector(
              '.PinturaControlPanels .PinturaShapeStyleEditor > div[style*="opacity: 1"] ul.PinturaShapeStyleList'
            );
            if (shapeStyleList) {
              shapeStyleList.appendChild(newListItem);
            }
          }, 500);
        }
      }
    }
  });

  window.pinturaEditor.on("backgroundChange", (newBackgroundSrc) => {
    window.pinturaEditor.setImageBackground(newBackgroundSrc); // Dynamically update background
  });

  const closeButton = document.createElement("button");
  closeButton.classList.add("close-button-editor-popup");
  document.querySelector(".inline-editor").appendChild(closeButton);

  closeButton.addEventListener("click", () => {
    showConfirmationModal(
      "Are you sure you want to exit? Any unsaved changes will be lost.",
      () => {
        // On confirm - close the editor
        window.pinturaEditor.destroy();
        closeButton.remove();
      },
      () => {
        // On cancel - do nothing (keep editor open)
        console.warn("Close cancelled");
      }
    );
  });

  window.pinturaEditor.on("process", (res) => {
    // Function to download the file
    downloadFile(res.dest);
  });
};

// Function to create and show custom confirmation modal
const showConfirmationModal = (message, onConfirm, onCancel) => {
  // Create the confirmation modal HTML
  const confirmationModal = document.createElement('div');
  confirmationModal.className = 'custom-confirmation-modal';
  confirmationModal.innerHTML = `
    <div class="confirmation-modal-overlay">
      <div class="confirmation-modal-content">
        <div class="confirmation-modal-header">
          <h3>Confirm Exit</h3>
        </div>
        <div class="confirmation-modal-body">
          <p>${message}</p>
        </div>
        <div class="confirmation-modal-footer">
          <button class="confirmation-btn confirmation-cancel-btn">Cancel</button>
          <button class="confirmation-btn confirmation-confirm-btn">Exit</button>
        </div>
      </div>
    </div>
  `;

  // Add event listeners
  const cancelBtn = confirmationModal.querySelector('.confirmation-cancel-btn');
  const confirmBtn = confirmationModal.querySelector('.confirmation-confirm-btn');
  const overlay = confirmationModal.querySelector('.confirmation-modal-overlay');

  cancelBtn.addEventListener('click', () => {
    document.body.removeChild(confirmationModal);
    if (onCancel) onCancel();
  });

  confirmBtn.addEventListener('click', () => {
    document.body.removeChild(confirmationModal);
    if (onConfirm) onConfirm();
  });

  // Close on overlay click
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      document.body.removeChild(confirmationModal);
      if (onCancel) onCancel();
    }
  });

  // Close on Escape key
  const handleEscape = (e) => {
    if (e.key === 'Escape') {
      document.body.removeChild(confirmationModal);
      document.removeEventListener('keydown', handleEscape);
      if (onCancel) onCancel();
    }
  };
  document.addEventListener('keydown', handleEscape);

  // Show the modal
  document.body.appendChild(confirmationModal);
};

// Define the addSmiley function
const addSmiley = (pintura, addPreset, smiley) => {
  // Ensure pintura is defined and annotatePresets is initialized
  if (!pintura) {
     return;
  }

  if (!pintura.annotatePresets) {
    pintura.annotatePresets = [];
  }

  // Update the recent smileys
  const recent = new Set([smiley, ...pintura.annotatePresets]);
  const recentArr = Array.from(recent);

  // Max of five
  if (recentArr.length > 5) recentArr.length = 5;
  pintura.annotatePresets = recentArr;

  // Add the smiley to the canvas
  addPreset(smiley);
};


document.addEventListener("DOMContentLoaded", function () {
  // Create a function to check for the buttons periodically
  const checkButtonExistence = setInterval(function () {
    const buttons = document.querySelectorAll(".quick-editor.guest-button");

    // If there are any buttons found, update each one
    if (buttons.length > 0) {
      buttons.forEach(function (button) {
        // Create an SVG element
        const svgElement = `
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M17.7586 5.73165L14.268 2.24024C14.1519 2.12414 14.0141 2.03204 13.8624 1.9692C13.7107 1.90637 13.5482 1.87402 13.384 1.87402C13.2198 1.87402 13.0572 1.90637 12.9056 1.9692C12.7539 2.03204 12.6161 2.12414 12.5 2.24024L2.86641 11.8746C2.74983 11.9903 2.65741 12.1279 2.59451 12.2796C2.5316 12.4313 2.49948 12.594 2.50001 12.7582V16.2496C2.50001 16.5811 2.6317 16.8991 2.86612 17.1335C3.10054 17.3679 3.41849 17.4996 3.75001 17.4996H7.24141C7.40563 17.5001 7.5683 17.468 7.71999 17.4051C7.87168 17.3422 8.00935 17.2498 8.12501 17.1332L17.7586 7.49962C17.8747 7.38354 17.9668 7.24573 18.0296 7.09405C18.0925 6.94238 18.1248 6.77981 18.1248 6.61563C18.1248 6.45145 18.0925 6.28889 18.0296 6.13721C17.9668 5.98554 17.8747 5.84772 17.7586 5.73165ZM7.24141 16.2496H3.75001V12.7582L10.625 5.88321L14.1164 9.37462L7.24141 16.2496ZM15 8.49024L11.5086 4.99962L13.3836 3.12462L16.875 6.61524L15 8.49024Z" fill="#C2C2C2"/>
          </svg>
        `;

        // Set the inner HTML of each button to include the SVG and text
        button.innerHTML = svgElement + " Quick Editor is exclusive to members";
      });

      clearInterval(checkButtonExistence); // Stop checking once all buttons are updated
    }
  }, 1000); // Check every second
});

const imageClickEditor = () => {
  // Attach click event listeners to images
  document.querySelectorAll(".editable-section img").forEach((img) => {
    img.addEventListener("click", function () {
      let productClicked = img.parentNode;
      let assetLink = editorSrc(productClicked);
      updateEditor(assetLink);
      // Scroll to the editor
      document.querySelector(".inline-editor").scrollIntoView({
        behavior: "smooth", // Smooth scroll
        block: "start", // Align to the start of the viewport
      });
    });
  });
};

// Function to show loading message
const showLoadingMessage = () => {
  document.body.classList.add('loading');
  
  // Create loading message overlay if it doesn't exist
  if (!document.getElementById('loading-message-overlay')) {
    const loadingOverlay = document.createElement('div');
    loadingOverlay.id = 'loading-message-overlay';
    loadingOverlay.innerHTML = `
      <div class="loading-message-content">
        <div class="loading-spinner"></div>
        <h3>Processing your file...</h3>
        <p>Please do not close this window until the operation is complete.</p>
        <p>Your file is being processed and uploaded.</p>
      </div>
    `;
    document.body.appendChild(loadingOverlay);
  }
  
  document.getElementById('loading-message-overlay').style.display = 'flex';
};

// Function to hide loading message
const hideLoadingMessage = () => {
  document.body.classList.remove('loading');
  const loadingOverlay = document.getElementById('loading-message-overlay');
  if (loadingOverlay) {
    loadingOverlay.style.display = 'none';
  }
};

const downloadFile = (file) => {
  showLoadingMessage();
  
  // Create a hidden link and set the URL using createObjectURL
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = URL.createObjectURL(file);
  link.download = file.name;

  // Add link to DOM and trigger download
  document.body.appendChild(link);
  link.click();

  // Cleanup
  setTimeout(() => {
    URL.revokeObjectURL(link.href);
    link.parentNode.removeChild(link);
  }, 0);
  handleFileUpload(file);

};

const handleFileUpload = async (file) => {
  try {
    // Step 1: Get pre-signed URL from backend
    const presignedUrlResponse = await fetch(middle_ware + "/shopify/generate-presigned-url", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: file.name,
        fileType: file.type,
        isThumb: false // Set to true for thumbnails/images
      }),
    });
    if (!presignedUrlResponse.ok) {
      throw new Error('Failed to get presigned URL');
    }

    const { presignedUrl, newFileName } = await presignedUrlResponse.json();

    // Step 2: Upload directly to S3 using presigned URL
    const uploadResponse = await fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error('Failed to upload file to S3');
    }

    // Step 3: Notify backend of successful upload (optional)
    const notifyResponse = await fetch(middle_ware + "/shopify/upload-complete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: file.name,
        fileUrlFe: newFileName,
        customerId: window.customerId,
        originalName: file.name,
        fileType: file.type,
        customEditorFinal: true
      }),
    });

    if (notifyResponse.ok) {
      const finalUrl = `https://d2bzq90r37yl3y.cloudfront.net/quick-editor-customer/${newFileName}`;
      console.info("File uploaded successfully");
    } else {
      console.error("Error notifying backend of upload completion");
    }

  } catch (error) {
    console.error("Error uploading file:", error);
  }
  hideLoadingMessage();
};

// Pintura End
const editableSectionShow = () => {
  document.querySelectorAll(".quick-editor").forEach((button) => {
    button.addEventListener("click", function () {
      // Check download limits
      if (document.body.classList.contains('no-more-downloads')) {
        showErrorPopup('Download limit reached! To unlock unlimited access, you\'ll need to upgrade to a full membership. Upgrading will conclude your free trial, and membership charges will begin right away.', 
        '/account?tab=membership', 
        'Activate Subscription');
        return;
      }
      document.querySelector(".modalEditor-popup").classList.add("show");
      document.body.classList.add("editor-open");
    });
  });
};

// Display the modal ONLY when the user is logged in as PRO
document.querySelector("button.quick-editor-download")?.addEventListener("click", function () {
  // Check download limits
  if (document.body.classList.contains('no-more-downloads')) {
    showErrorPopup('Download limit reached! To unlock unlimited access, you\'ll need to upgrade to a full membership. Upgrading will conclude your free trial, and membership charges will begin right away.', 
    '/account?tab=membership', 
    'Activate Subscription');
    return;
  }
  document.querySelector(".modalEditor-popup").classList.add("show");
  document.body.classList.add("editor-open");
});
const editorSrc = (product) => {
  // Get selected resolution
  const selectedResolution = document.querySelector('input[type="radio"][name="resolution"]:checked').value;
  const selectedWidth = 'sw'; // Default to standard width
  const type = product.getAttribute("data-type");
  
  // Find matching product in productPackArray
  const matchingProduct = productPackArray.find(p => 
    p.title.toLowerCase() === product.querySelector('.product-actions h4').innerHTML.toLowerCase() && 
    p.productType.toLowerCase() === type.toLowerCase()
  );

  if (!matchingProduct?.awsLinkExport?.value) {
    console.error("AWS link data not available");
    return product.querySelector("img").src; // Fallback to image src
  }

  try {
    // Parse AWS link export data
    const awsLinks = JSON.parse(matchingProduct.awsLinkExport.value).aws_link;
    
    // Get available formats for current resolution
    const availableFormats = [...new Set(awsLinks
      .filter(link => link.variant.includes(selectedResolution.toLowerCase()))
      .map(link => link.variant.split('_')[0])
    )];

    // Select format based on type and availability
    let format;
    if (type === "Stills") {
      format = availableFormats.includes('jpg') ? 'jpg' : availableFormats[0];
    } else {
      format = availableFormats.includes('mp4') ? 'mp4' : availableFormats[0];
    }

    const variantKey = `${format}_${selectedResolution.toLowerCase()}${selectedWidth === 'tw' ? '_tw' : ''}`;

    // Find matching AWS link
    const matchingLink = awsLinks.find(link => link.variant === variantKey);

    if (matchingLink) {
      return matchingLink.aws_link;
    }
  } catch (error) {
    console.error("Error processing editor source:", error);
  }

  // Fallback to image src if no matching link found
  return product.querySelector("img").src;
}

// Function to handle filtering
const filterItems = () => {
  // Get the selected filter type
  const selectedType = document.querySelector('input[type="radio"][name="format"]:checked').value.toLowerCase();
  // Toggle classes based on the selected type
  document.body.classList.toggle("editor-motions", selectedType === 'motion');
}
// Function to open the single quick editor on Motions and Stills
const openSingleQuickEditor = () => {
  if (document.body.classList.contains('no-more-downloads')) {
    showErrorPopup('Download limit reached! To unlock unlimited access, you will need to upgrade to a full membership. Upgrading will conclude your free trial, and membership charges will begin right away.', '/account?tab=membership', 'Activate Subscription');
    return;
  }

  if (!awsLinkExportSingle || !awsLinkExportSingle.aws_link) {
    console.log('No AWS link data available');
    return;
  }

  const links = awsLinkExportSingle.aws_link;
  
  // First try to find HD quality (jpg_hd or mp4_hd)
  let selectedLink = links.find(link => 
    link.variant === 'jpg_hd' || link.variant === 'mp4_hd'
  );
  
  // If no HD found, try SD quality (jpg_sd or mp4_sd)
  if (!selectedLink) {
    selectedLink = links.find(link => 
      link.variant === 'jpg_sd' || link.variant === 'mp4_sd'
    );
  }
  
  // If still nothing, get any jpg or mp4
  if (!selectedLink) {
    selectedLink = links.find(link => 
      link.variant.includes('jpg') || link.variant.includes('mp4')
    );
  }
  
  if (selectedLink) {
    console.log('Selected asset link:', selectedLink.aws_link);
    updateEditor(selectedLink.aws_link);
    document.querySelector(".inline-editor").scrollIntoView({
      behavior: "smooth", // Smooth scroll
      block: "start", // Align to the start of the viewport
    });
    // TODO: Open the editor with this link
  } else {
    showErrorPopup('No suitable asset found. Editor is not available for this product.');
    return;
  }
}